import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 20,
        css:css`
            > div{
                margin: 0px;
                justify-content: space-between;
            }

            &.catalog-product-list >div{
                width: 100%;
            }
            .sidebar{
                padding: 0;
                height: max-content;
                border: 1px solid #e1e1e1;

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        max-width: 250px;
                        `,
                    ],
                    "min",
                )}

                [role="presentation"] {
                    padding-top: 0;
                }

                label,[data-test-selector="sectionHeader"] button span{
                    font-size: 15px;
                    line-height: 23px;
                    color: #708090;
                    font-weight: 600;
                    cursor: pointer;
                }
                span[role=checkbox][aria-checked="true"]:not([aria-disabled="true"]) {
                    margin-top: 3px !important;
                }

                [data-id*="checkbox"] span[role="checkbox"]{
                    +label {
                        font-size: 14px;
                        line-height: 22px;
                        color: #1c3e95;
                        cursor: pointer;
                        font-weight: 400;
                        vertical-align: middle;
    
                        &:hover{
                            text-decoration: underline;
                        }
                    } 
                    &[aria-checked="true"] +label{
                        font-weight: 600; 
                    }
                }
                div[class*="CheckboxGroupStyle"]{
                    span{
                        margin: 0;
                    }
                
                }
                span[role="checkbox"] {
                    margin-top: 3px !important;
                }
            }
            .main-content{
                padding:0;

                .grid-item {
                    border: 1px solid #e0e0e0;
                    padding: 0px;
                }

                .mfg-wrap span,
                .product-num-brand .product-num-wrap span {
                    font-size: 14px;
                    line-height: 22px;
                    color: #8a8a8a;
                }

                .grid-item-wrapper {
                    border-bottom: none;
                    padding: 15px;
    
                    > div {
                        padding-bottom: 0;
                    }

                    [data-test-selector*="productListProductCard"] > div{
                        padding:0;
                    }
                }

                .product-list-pagination{
                    clear: both;
                    width: 100%;
                    float: left;
                    text-align: center;
                    padding: 6px 16px;
                    border: 1px solid #e0e0e0;
                    background: #fff;
                    box-shadow: inset 0 0 7px 0 rgba(0, 0, 0, .1);
                    border-radius: 4px;
                }
                .unit-of-mesure {
                    margin-bottom: 0;
                }
                .unit-of-mesure ~ [class*="IconWrapper"]{
                    display: none;
                }
                .qty-add-to-cart-wrap{
                    margin-top: 0;
                    input:not(.react-datetime-picker__inputGroup__input){
                        margin-bottom:0;
                    }
                    label{
                        display:none;
                    }
                    button{
                        min-height: 36px;
                    }
                } 

                table .btn-add-to-list{
                    margin-bottom:10px;
                }

                .product-list-card-list{
                    border: 1px solid #e0e0e0;

                    .card_container__wrapper{
                        margin: 0;

                        &:last-child {
                            border-bottom: none;
                        }
                    }
                }

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        padding-left:15px;
                        `,
                    ],
                    "min",
                )}
            }
        `
    },
    leftColumnGridItem: {
        width: [12, 12, 3, 3, 3],
    },
    leftColumnTableViewGridItem: {
        width: [12, 12, 0, 0, 0],
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
    },
    rightColumnTableViewGridItem: {
        width: 12,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id, view }) => {
    const leftColumnGridItemStyle = view === "Table" ? styles.leftColumnTableViewGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle =
        view === "Table" ? styles.rightColumnTableViewGridItem : styles.rightColumnGridItem;
    return (
        <GridContainer className="catalog-product-list" {...styles.container}>
            <GridItem className="sidebar" {...leftColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem className="main-content" {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListColumns),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
